import { Icons, Input } from '@commenda/kakashi';
import {
  EventHandlerEventType,
  TEventHandlerDefinition,
} from '@commenda/types';
import { EventHandlerActionEditor } from './EventHandlerActionEditor';
import { EventHandlerScheduleEditor } from './EventHandlerScheduleEditor';

const EVENT_TYPES: Record<EventHandlerEventType, { description: string }> = {
  [EventHandlerEventType.STEP_ATTEMPT_STARTED]:
    { description: 'Runs if the step is still open when the delay ends' },
  [EventHandlerEventType.STEP_ATTEMPT_ENDED]:
    { description: 'Runs after the step ends' },
};

export const EventHandlerCard = ({
  eventHandler,
  ownerStepId,
  onChange,
  onDelete,
}: {
  eventHandler: TEventHandlerDefinition;
  ownerStepId: string;
  onChange: (eventHandler: TEventHandlerDefinition) => void;
  onDelete: () => void;
}) => (
  <div className="flex flex-col gap-4 rounded-md border border-stroke-3 p-3">
    <div className="flex items-center gap-2">
      <Input
        className="grow"
        placeholder="Event handler name"
        value={eventHandler.name ?? ''}
        onChange={(e) => onChange({ ...eventHandler, name: e.target.value })}
      />
      <Icons.Trash02 className="size-4 cursor-pointer" onClick={onDelete} />
    </div>
    <span className="text-text-secondary txt-small-regular">
      {EVENT_TYPES[eventHandler.when.eventType].description}
    </span>
    <EventHandlerScheduleEditor
      value={eventHandler.schedule}
      onChange={(schedule) => onChange({ ...eventHandler, schedule })}
    />
    <EventHandlerActionEditor
      action={eventHandler.action}
      ownerStepId={ownerStepId}
      fieldsKey={`${ownerStepId}-${eventHandler.id}`}
      onChange={(action) => onChange({ ...eventHandler, action })}
    />
  </div>
);
